export const FormsScope = "FormsScope";
export const StatusScope = "StatusScope";
export const CrmStatusScope = "CrmStatusScope";
export const StudioScope = "StudioScope";
export const OrdersScope = "OrdersScope";
export const PartnerCenterScope = "PartnerCenterScope";
export const CurrentProgramScope = "CurrentProgramScope";
export const ProgramsScope = "ProgramsScope";
export const CapabilitiesScope = "CapabilitiesScope";
export const TicketingScope = "TicketingScope";
export const XboxOnboardScope = "XboxOnboardScope";
export const IdXboxProgramScope = "IdXboxProgramScope";
export const GameConceptPageScope = "GameConceptPageScope";
export const GameConceptsScope = "GameConceptsScope";
export const PitchPageScope = "PitchPageScope";
export const PitchListScope = "PitchListScope";
export const AdminPageScope = "AdminPageScope";
